import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/breadcrumb.css';

const Breadcrumb = ({ customPath = null, customLabel = null }) => {
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
  
  // Use custom path if provided, otherwise use current location
  const currentPath = customPath || location.pathname;
  const pathSegments = currentPath.split('/').filter(segment => segment !== '');
  
  // Service page mappings for better labels
  const pathLabels = {
    'landscape': 'Design & Build',
    'hardscape': 'Hardscape',
    'maintenance': 'Maintenance',
    'snow': 'Snow Removal',
    'tree': 'Tree Services',
    'treefarm': 'Tree Farm',
    'fire': 'Fire Features',
    'light': 'Holiday Lighting',
    'flower': 'Seasonal Flowers',
    'waterfeature': 'Water Features',
    'fencing': 'Fencing',
    'gallery': 'Portfolio',
    'projects': 'Featured Projects',
    'premium': 'Signature Services',
    'propertymanagementpage': 'Property Management',
    'residentialclientpage': 'Residential Services',
    'teampage': 'About & Team',
    'careerspage': 'Careers',
    'ecopage': 'Eco-Friendly Practices'
  };

  // Scroll listener to show/hide breadcrumb
  useEffect(() => {
    const handleScroll = () => {
      // Show breadcrumb after scrolling past hero section (approximately 70vh)
      const scrollThreshold = window.innerHeight * 0.7;
      setIsVisible(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Don't show breadcrumbs on home page
  if (pathSegments.length === 0) return null;

  return (
    <nav 
      className={`breadcrumb ${isVisible ? 'breadcrumb--visible' : 'breadcrumb--hidden'}`} 
      aria-label="Breadcrumb navigation"
    >
      <div className="breadcrumb-container">
        <img 
          src="/images/LeafASL.png" 
          alt="All Seasons Leaf" 
          className="breadcrumb-logo"
        />
        <Link to="/" className="breadcrumb-link breadcrumb-home">
          <svg className="breadcrumb-home-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
            <polyline points="9,22 9,12 15,12 15,22"/>
          </svg>
          Home
        </Link>
        
        {pathSegments.map((segment, index) => {
          const path = '/' + pathSegments.slice(0, index + 1).join('/');
          const isLast = index === pathSegments.length - 1;
          const label = customLabel && isLast ? customLabel : 
                       pathLabels[segment.toLowerCase()] || 
                       segment.charAt(0).toUpperCase() + segment.slice(1);

          return (
            <React.Fragment key={path}>
              <span className="breadcrumb-separator">›</span>
              {isLast ? (
                <span className="breadcrumb-current" aria-current="page">
                  {label}
                </span>
              ) : (
                <Link to={path} className="breadcrumb-link">
                  {label}
                </Link>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </nav>
  );
};

export default Breadcrumb;